import Api from './Api';

const endpoint = 'suggestion';


export default class SuggestionService extends Api {

    async all (filter) {
        const response = await this.client.get(`${endpoint}/all`, {
            params: {
                field: 'name',
                value: filter
            }
        });
        if (response.data) {
            return response.data.map(s => {
                return {
                    value: s.id,
                    text: s.complete_name
                }
            })
        }
        throw new Error('No data')
    }
}
